/*
 * File: useAppointments.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2020 MacPractice, Inc. All rights reserved.
 *
 * Description: State manager for fetching todays appointments from the api
 */
import { useState, useEffect } from "react";
import ApptsApi from "services/appointments/Api";
import { format } from "date-fns";

const useAppointments = () => {
  const [appts, setAppts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      const filter = "/?date=" + format(new Date(), "yyyy-MM-dd");
      const newAppts = await ApptsApi.fetch(filter);
      setAppts(newAppts);
      setLoading(false);
    };
    fetchData();
  }, []);

  return { appts: appts, loading: loading };
};

export default useAppointments;
